module.exports = __webpack_public_path__ + "media/images/flags/ph-596b9b66d026fa222c2d4a055e7f299d.svg";